var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.003,
    height: 128,
    viewBox: "0 0 96.003 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_728987_experiment_chemistry_lab_laboratory_research_icon",
    "data-name": "728987_experiment_chemistry_lab_laboratory_research_icon",
    transform: "translate(-15.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M60,32A12,12,0,1,0,48,20,12.013,12.013,0,0,0,60,32Zm0-16a4,4,0,1,1-4,4A4,4,0,0,1,60,16ZM76,8a4,4,0,1,0-4-4A4,4,0,0,0,76,8ZM24,120h8v-8H24Zm0-16h8V96Zm8,0v8h8v-8Zm8-16H32v8h8Zm8-8H40v8h8ZM40,96v8h8V96Zm0,24h8v-8H40Zm8-16v8h8v-8Zm8-8V88H48v8Zm8-16H56v8h8ZM56,96v8h8V96Zm0,24h8v-8H56Zm8-16v8h8v-8Zm8-8V88H64v8Zm8-16H72v8h8ZM72,96v8h8V96Zm0,24h8v-8H72Zm8-16v8h8v-8Zm8-8V88H80v8Zm8,8V96H88v8Zm-8,16h8v-8H88Zm8-16v8h8v-8Z",
    fill: "#32bf00",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M110.415,110.047,80,58.938V48h4a4,4,0,0,0,0-8H76a4,4,0,0,0-4,4V60a4.016,4.016,0,0,0,.527,1.984l30.645,51.578A4,4,0,0,1,100,120H28a4,4,0,0,1-3.172-6.437L55.473,61.984A4.006,4.006,0,0,0,56,60V44a4,4,0,0,0-4-4H44a4,4,0,0,0,0,8h4V58.938L17.582,110.047A12,12,0,0,0,28,128h72a12,12,0,0,0,10.415-17.953Z",
    fill: "#546e7a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/test-icon.2b1ada73e6e33301aeac287a15063a4a.svg";
export { ForwardRef as ReactComponent };